import { actions } from '@store/ducks/auth';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import TStore from 'types/store';
import ChevronButton from '../../../components/chevron-button';
import Header from '../../../components/header';
import { StepLandingSC } from './step-landing.styled';

const StepLanding: React.FC = () => {
  const step = useSelector((state: TStore) => state.auth.currentRegStep);
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    dispatch(actions.setCurrentRegStep(step + 1));
  };

  return (
    <StepLandingSC>
      <Header step={step} textId="reg.step_0.title" />
      <div className="text">
        <FormattedMessage id="reg.step_0.welcome_text" />
      </div>
      <ChevronButton textId="reg.step_0.btn_text" goForth={handleButtonClick} />
    </StepLandingSC>
  );
};
export default StepLanding;
